<template>
    <Row class="ly-drag-edit" :gutter="10">
        <Col span="12">
            <ly-nested-draggable :mark="currModule.name" :modules="list" @change="moduleChange" @click="listenBtnEmit"/>
        </Col>
        <Col span="6">
            <Card dis-hover>
                <div class="module-title" slot="title">
                    <template v-if="currModule.name">
                        {{currModule.name}}包含的公司
                    </template>
                    <template v-else>还未选中模块</template>
                </div>
                <template v-if="currModule.company && currModule.company.length > 0">
                    <Tag type="dot" closable  v-for="(el,i) in currModule.company" :key="i" color="success" @on-close="removeCompany(i)">{{el.name}}</Tag>
                </template>
                <draggable class="no-data" :list="currModule.company" group="company">
                    将公司拖拽到此处
                </draggable>
            </Card>
        </Col>
        <Col span="6">
            <Card dis-hover>
                <div slot="title">
                    <Input icon="ios-search" placeholder="请输入公司名称查找" v-model="searchText">
                        <Button slot="append" icon="ios-search" @click="queryCompany"></Button>
                    </Input>
                </div>
                <draggable class="list-group" :list="companyList" :group="{name: 'company', pull: 'clone'}">
                    <div
                        class="list-group-item"
                        v-for="(element, index) in companyList"
                        :key="index"
                    >
                     {{ index }}、{{ element.name }}
                    </div>
                </draggable>

                <div class="no-data" v-if="companyList.length < 1">
                    暂无数据
                </div>
            </Card>
        </Col>
        <!-- 新增子模块的弹窗 start -->
         <Modal
            v-model="modalValue"
            :title="modalTitle"
            @on-ok="operModule"
            @on-cancel="modalValue = false">
                <Input v-model="moduleName" size="large" placeholder="模块名称" />
        </Modal>
        <!-- 新增子模块的弹窗  end  -->
    </Row>
</template>
<script>
    import LyNestedDraggable from "./nested";
	import draggable from "vuedraggable"
    export default {
        props: {
            list: {
                type: Array,
                default: () => []
            },
            api: { // 查询公司的接口
                type: String,
                default: ''
            }
        },
        components: {
            draggable,
            LyNestedDraggable
        },
        data() {
            return {
                currModule: {}, // 当前选中的模块
                searchText: '',
                companyList: [],
                modalValue: false,
                modalTitle: '',
                currUseInfo: {}, // 操作的详情信息
                moduleName: ''
            }
        },
        computed: {
            canPut () {
                return this.currModule.id > 0 
            }
        },
        methods: {
            moduleChange (change) {
                if (!change.hasOwnProperty('company')) {
                    this.$set(change, 'company', [])
                }
                this.currModule = change
            },
            /**
             * 查询公司的数据
             */
            queryCompany () {
                console.log('==> this.api:%O', this.api)
                this.$api.query(this.api, {
                    keyword: this.searchText
                }).then((rs) => {
                    this.companyList = rs
                    console.log('rs:%O', rs)
                }).catch((err) => {
                    this.$Message.error({content: err, duration: 5 })
                })
            },
            /**
             * 移除当前模块中的
             */
            removeCompany (index) {
                const company = this.currModule.company[index]
                // 2023-07-20记录，说的是删除模块要求请求删除接口，不与保存一样
                this.$api.delete('pc/mconfig/' + company.id)
                this.currModule.company.splice(index, 1)
            },
            listenBtnEmit (obj) {
                this.currUseInfo = obj
                switch (obj.type) {
                    case 'add':
                        this.modalTitle = '添加子模块'
                    break
                    case 'edit':
                        this.modalTitle = '编辑模块'
                        this.moduleName = obj.module.name
                    break
                }
                this.modalValue = true
            },
            /**
             * 添加子模块
             */
            operModule () {
                if (this.currUseInfo.type == 'add' && this.moduleName.length > 0) {
                    this.currUseInfo.module.modules.unshift({
                        name: this.moduleName,
						modules: [],
						company: []
                    })
                    this.moduleName = ''
                } else if (this.currUseInfo.type == 'edit' && this.moduleName.length > 0) {
                    this.currUseInfo.module.name = this.moduleName
                    this.moduleName = ''
                }
            }
        }
    }
</script>
<style>
    .ly-drag-edit .comany-item,
    .ly-drag-edit .list-group-item {
        display: block;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        height: 32px;
        line-height: 30px;
        padding: 0 15px;
        margin: 10px 0;
    }

    .ly-drag-edit .ivu-card-head {
        padding: 10px;
    }
    .ly-drag-edit .module-title {
        height: 32px;
        line-height: 32px;
    }
    .ly-drag-edit .no-data {
        text-align: center;
        color: #aaa;
        height: 100px;
        line-height: 100px;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/drag-list/src/edit.vue